/**
 * Event Types Constants
 */

export const EVENT_TYPES = {
  INTERVIEW: 'interview',
  EXAM: 'exam',
  PROCESS: 'process',
  PRE_DEPARTURE: 'pre-departure',
  DEPARTURE: 'departure',
  COMPLETED: 'completed',
  FULL_DAY_LEAVE: 'full_day_leave',
  HALF_DAY_LEAVE: 'half_day_leave'
};

export const EVENT_TYPE_LABELS = {
  [EVENT_TYPES.INTERVIEW]: 'Interview',
  [EVENT_TYPES.EXAM]: 'Exam',
  [EVENT_TYPES.PROCESS]: 'Pre-Departure',
  [EVENT_TYPES.PRE_DEPARTURE]: 'Pre-Departure',
  [EVENT_TYPES.DEPARTURE]: 'Departure',
  [EVENT_TYPES.COMPLETED]: 'Completed',
  [EVENT_TYPES.FULL_DAY_LEAVE]: 'Full Day Leave',
  [EVENT_TYPES.HALF_DAY_LEAVE]: 'Half Day Leave'
};

export const EVENT_TYPE_COLORS = {
  [EVENT_TYPES.INTERVIEW]: {
    bg: 'bg-blue-100',
    text: 'text-blue-900',
    border: 'border-l-blue-600',
    badge: 'bg-blue-600 text-white',
    light: 'text-blue-600 bg-blue-50'
  },
  [EVENT_TYPES.EXAM]: {
    bg: 'bg-red-100',
    text: 'text-red-900',
    border: 'border-l-red-600',
    badge: 'bg-red-600 text-white',
    light: 'text-red-600 bg-red-50'
  },
  [EVENT_TYPES.PROCESS]: {
    bg: 'bg-amber-100',
    text: 'text-amber-900',
    border: 'border-l-amber-500',
    badge: 'bg-amber-500 text-white',
    light: 'text-amber-600 bg-amber-50'
  },
  [EVENT_TYPES.PRE_DEPARTURE]: {
    bg: 'bg-amber-100',
    text: 'text-amber-900',
    border: 'border-l-amber-500',
    badge: 'bg-amber-500 text-white',
    light: 'text-amber-600 bg-amber-50'
  },
  [EVENT_TYPES.DEPARTURE]: {
    bg: 'bg-purple-100',
    text: 'text-purple-900',
    border: 'border-l-purple-600',
    badge: 'bg-purple-600 text-white',
    light: 'text-purple-600 bg-purple-50'
  },
  [EVENT_TYPES.COMPLETED]: {
    bg: 'bg-gray-100',
    text: 'text-gray-900',
    border: 'border-l-gray-600',
    badge: 'bg-gray-600 text-white',
    light: 'text-gray-600 bg-gray-50'
  },
  [EVENT_TYPES.FULL_DAY_LEAVE]: {
    bg: 'bg-red-100',
    text: 'text-red-900',
    border: 'border-l-red-600',
    badge: 'bg-red-600 text-white',
    light: 'text-red-600 bg-red-50'
  },
  [EVENT_TYPES.HALF_DAY_LEAVE]: {
    bg: 'bg-orange-100',
    text: 'text-orange-900',
    border: 'border-l-orange-600',
    badge: 'bg-orange-600 text-white',
    light: 'text-orange-600 bg-orange-50'
  }
};

export const EVENT_TYPE_ICONS = {
  [EVENT_TYPES.INTERVIEW]: '👥',
  [EVENT_TYPES.EXAM]: '📝',
  [EVENT_TYPES.PROCESS]: '✈️',
  [EVENT_TYPES.PRE_DEPARTURE]: '✈️',
  [EVENT_TYPES.DEPARTURE]: '🛫',
  [EVENT_TYPES.COMPLETED]: '✅',
  [EVENT_TYPES.FULL_DAY_LEAVE]: '🏖️',
  [EVENT_TYPES.HALF_DAY_LEAVE]: '🕐'
};

export const getEventTypeClass = (eventType) => {
  const colors = EVENT_TYPE_COLORS[eventType] || EVENT_TYPE_COLORS[EVENT_TYPES.INTERVIEW];
  return `${colors.bg} ${colors.text} ${colors.border}`;
};

export const getEventTypeColor = (eventType) => {
  const colors = EVENT_TYPE_COLORS[eventType] || EVENT_TYPE_COLORS[EVENT_TYPES.INTERVIEW];
  return colors.light;
};

export const getEventTypeBadge = (eventType) => {
  const colors = EVENT_TYPE_COLORS[eventType] || EVENT_TYPE_COLORS[EVENT_TYPES.INTERVIEW];
  return colors.badge;
};

export const getEventTypeIcon = (eventType) => {
  return EVENT_TYPE_ICONS[eventType] || EVENT_TYPE_ICONS[EVENT_TYPES.INTERVIEW];
};